// Copyright ©️ 2026 eVolve MEP, LLC

import React, { type ReactNode } from 'react';

import { isNil } from 'helpers/isNotNil';

export const emptyChildren = (children: ReactNode) =>
  React.Children.count(children) === 0 ||
  React.Children.toArray(children).every(isNil) ||
  (typeof children === 'string' && !children.trim());
